/* eslint-disable */
import Vue from 'vue'
let database = {
    db: null,
    isIndexedDbEnabled(){
        return ('indexedDB' in window) && this.db != null;
    },
    async get(storeName, key){
        let result = [];
        const transaction = this.db.transaction(storeName, 'readonly');
        const objectStore = transaction.objectStore(storeName);

        let promise = new Promise(function(resolve){
            objectStore.get(key).onsuccess = async function(event) {
                result = event.target.result;
                await transaction.done;
                resolve(event.target.result)
            };                
        }); 

        return promise;
    },    
    async getAll(storeName){
        let result = [];
        const transaction = this.db.transaction(storeName, 'readonly');
        const objectStore = transaction.objectStore(storeName);

        let promise = null;
        if ('getAll' in objectStore) {
            promise = new Promise(function(resolve){
                objectStore.getAll().onsuccess = async function(event) {
                    result = event.target.result;
                    await transaction.done;
                    resolve(event.target.result)
                };                
            });
        } 
        else {
            promise = new Promise(function(resolve){
                objectStore.openCursor().onsuccess = async function(event) {
                    var cursor = event.target.result;
                    if (cursor) {
                        result.push(cursor.value);
                        cursor.continue();
                    } 
                    else{
                        await transaction.done;
                        resolve(result);
                    }
                };            
            });
        }   

        return promise;
    },
    async addAll(storeName, collection){
        const transaction = this.db.transaction(storeName, 'readwrite');
        const objectStore = transaction.objectStore(storeName);

        collection.forEach(async element => {
            await objectStore.add(element);
        });   

        await transaction.done;
    },
    async add(storeName, item){
        const transaction = this.db.transaction(storeName, 'readwrite');
        const objectStore = transaction.objectStore(storeName);

        await objectStore.add(item);
        await transaction.done;
    },
    async update(storeName, key, item){
        const transaction = this.db.transaction(storeName, 'readwrite');
        const objectStore = transaction.objectStore(storeName);

        await objectStore.put(item);
        await transaction.done;
    },    
    async deleteAll(storeName){
        const list = await this.getAll(storeName);

        const transaction = this.db.transaction(storeName, 'readwrite');
        const objectStore = transaction.objectStore(storeName);

        list.forEach(async element => {
            await objectStore.delete(element.id);
        });   

        await transaction.done;
    },  
    async getDailyCacheTable(storeName){
        let date = new Date();
        let utcDate = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 12, 0, 0, 0); 

        const addDate = new Date(utcDate).getTime();         
        const STORE_NAME = "table-cache";

        return await this.get(STORE_NAME, `${storeName}-${addDate}`);
    },
    async setDailyCacheTable(storeName){
        let date = new Date();
        let utcDate = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 12, 0, 0, 0); 

        const addDate = new Date(utcDate).getTime();         
        const STORE_NAME = "table-cache";

        return await this.add(STORE_NAME, {
            id: `${storeName}-${addDate}`,
            tableName: storeName,
            addDate: date
        });
    }                  
};

/* eslint-disable */
window.onload = async function() {

    let request = window.indexedDB.open('sondaworkspace_db');
    request.onupgradeneeded = function(e) {
        let db = e.target.result;

        let objectStore = db.createObjectStore('posicao', { keyPath: 'id', autoIncrement:false });
        objectStore.createIndex('id', 'id', { unique: true });

        objectStore = db.createObjectStore('centro-custo', { keyPath: 'id', autoIncrement:false });
        objectStore.createIndex('id', 'id', { unique: true });        

        objectStore = db.createObjectStore('cargo', { keyPath: 'id', autoIncrement:false });
        objectStore.createIndex('id', 'id', { unique: true });         

        objectStore = db.createObjectStore('empresa', { keyPath: 'id', autoIncrement:false });
        objectStore.createIndex('id', 'id', { unique: true });    
        
        objectStore = db.createObjectStore('divisao', { keyPath: 'id', autoIncrement:false });        
        objectStore.createIndex('id', 'id', { unique: true });          

        objectStore = db.createObjectStore('localidade', { keyPath: 'id', autoIncrement:false });
        objectStore.createIndex('id', 'id', { unique: true });                  

        objectStore = db.createObjectStore('onboarding-paises-parametrizados', { keyPath: 'id', autoIncrement:false });        
        objectStore.createIndex('id', 'id', { unique: true });         

        objectStore = db.createObjectStore('onboarding-lista-valores', { keyPath: 'id', autoIncrement:false });        
        objectStore.createIndex('id', 'id', { unique: true });               

        objectStore = db.createObjectStore('table-cache', { keyPath: 'id', autoIncrement:false });
        objectStore.createIndex('id', 'id', { unique: true });       
    };    

    request.onerror = function() {
        console.log('Database failed to open');
    };
    
    request.onsuccess = async function() {
        database.db = request.result;    
    };    
};


Vue.prototype.$db = database;